import { useState, useEffect } from "react";
import styles from "./EventCard.module.scss";
import { useTranslation } from "react-i18next";
import OptionsGroup from "./OptionsGroup";
import _ from "lodash";

const EventCard = (props) => {
  const { t } = useTranslation();
  const { data, error, setValue, trigger, setPrice } = props;
  const { name, poster } = data || {};

  const [selectedOption, setSelectedOption] = useState(null);
  const [optionsList, setOptionsList] = useState([]);
  const [dirty, setDirty] = useState(false);

  // Add unique Id to every options and put it into a optionList
  const initsku = () => {
    return data.sku.map((groupData) => {
      const _options = groupData.options.map((option) => {
        option.id = _.uniqueId("opt_");
        setOptionsList((prev) => {
          const _prev = [...prev];
          _prev.push(option);
          return _prev;
        });
        return option;
      });
      groupData.options = _options;
      return groupData;
    });
  };
  const [sku, setSku] = useState(initsku);

  const optionsGroupProps = {
    optionProps: {
      setDirty,
      setValue,
      selectedOption,
      setSelectedOption,
      setPrice,
    },
  };

  useEffect(() => {
    if (dirty) trigger("option");
  }, [dirty, trigger, selectedOption]);

  return (
    <div className={`card-view ${styles.card} ${props.xc || ""}`}>
      <div className="container">
        <div className="image-div">
          <img src={poster} alt="event-detail-poster" />
        </div>
        <div className="options-div">
          <h1>{name}</h1>
          <h4 className={`my-2 ${error ? "error-text" : ""}`}>{t("Please select")}</h4>
          {sku.map((groupData, i) => (
            <OptionsGroup key={_.uniqueId("opt_gp_")} {...groupData} {...optionsGroupProps} optGpIndex={i} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default EventCard;
